import {Component, inject, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {MatDialogRef} from '@angular/material/dialog';
import {ButtonSize, ButtonState, ButtonType, InputSize, InputState} from '../../../assets/types/dtoTypes';
import {ButtonComponent} from '../../shared/button/button.component';
import {InputComponent} from '../../shared/input/input.component';
import {TranslateModule} from '@ngx-translate/core';
import {MatError} from '@angular/material/select';
import {NgIf} from '@angular/common';
import {ContactPopupModalService} from '../contact-popup-modal/contact-popup-modal.service';

@Component({
  selector: 'app-employer-partner-modal',
  templateUrl: './employer-partner-modal.component.html',
  standalone: true,
  imports: [
    ButtonComponent,
    InputComponent,
    TranslateModule,
    ReactiveFormsModule,
    MatError,
    NgIf,
  ],
  styleUrl: './employer-partner-modal.component.scss'
})
export class EmployerPartnerModalComponent implements OnInit {
  private fb = inject(FormBuilder);
  private dialogRef = inject<MatDialogRef<EmployerPartnerModalComponent>>(MatDialogRef);
  private contactService = inject(ContactPopupModalService);

  partnerForm: FormGroup;
  isSubmitting = false;
  isError = false;

  protected readonly InputSize = InputSize;
  protected readonly InputState = InputState;
  protected readonly ButtonSize = ButtonSize;
  protected readonly ButtonState = ButtonState;
  protected readonly ButtonType = ButtonType;

  ngOnInit(): void {
    this.partnerForm = this.fb.group({
      companyName: ['', Validators.required],
      contactPerson: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      phone: ['', Validators.required],
    });
  }

  isInvalidAndTouched(field: string): boolean {
    const control = this.partnerForm.get(field);
    return !!control && !control.valid && control.touched;
  }

  onSubmit(): void {
    if (!this.partnerForm.valid) {
      this.partnerForm.markAllAsTouched();
      return;
    }

    this.isSubmitting = true;
    const formData = {
      companyName: this.partnerForm.get('companyName')?.value,
      contactPerson: this.partnerForm.get('contactPerson')?.value,
      email: this.partnerForm.get('email')?.value,
      phoneNumber: this.partnerForm.get('phone')?.value,
    };

    this.contactService.sendContactForm(formData).subscribe({
      next: () => {
        this.dialogRef.close();
      },
      error: () => {
        this.isError = true;
        this.isSubmitting = false;
      },
    });
  }
}